import React, { useState, useEffect } from "react";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../../shared/assets/images/Logo.png";
import LogoFallback from "../../../shared/assets/images/Logo.png";

// Nawigacja dla strony głównej (tatuaże)
const tattooNavigation = [
  { name: "O nas", href: "AboutUs" },
  { name: "Jak się umówić", href: "HowToBook" },
  { name: "Pielęgnacja", href: "Care" },
  { name: "Lokalizacja", href: "Location" },
  { name: "Nasza ekipa", href: "Team" },
];

// Nawigacja dla strony piercingu
const piercingNavigation = [
  { name: "O nas", href: "AboutPiercing" },
  { name: "Jak się umówić", href: "HowToBookPiercing" },
  { name: "Cennik", href: "PricingPiercing" },
];

// Nawigacja dla strony lasera - NOWA!
const laserNavigation = [
  { name: "O Laserze", href: "about-laser" },
  { name: "Usługi", href: "gallery-laser" },
  { name: "Jak przebiega", href: "process-laser" },
  { name: "Cennik", href: "pricing-laser" },
];

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Wykrywanie aktualnej strony
  const isPiercingPage = location.pathname.includes("/piercing");
  const isLaserPage = location.pathname.includes("/laser");

  // Wybierz odpowiednią nawigację w zależności od aktualnej strony
  let navigation = tattooNavigation;
  let currentPagePath = "/";

  if (isPiercingPage) {
    navigation = piercingNavigation;
    currentPagePath = "/piercing";
  } else if (isLaserPage) {
    navigation = laserNavigation;
    currentPagePath = "/laser";
  }

  // Funkcja do generowania linków do innych stron
  const getOtherPageLinks = () => {
    const allPages = [
      { name: "Tatuaże", path: "/" },
      { name: "Piercing", path: "/piercing" },
      { name: "Laser", path: "/laser" },
    ];

    return allPages.filter((page) => page.path !== currentPagePath);
  };

  // Efekt do scrollowania do elementu po załadowaniu strony, jeśli w URL jest hash
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.substring(1); // Usuń znak # z hash
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500); // Małe opóźnienie, żeby dać czas na wyrenderowanie komponentów
    }
  }, [location]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleNavigation = (sectionId) => {
    if (mobileMenuOpen) {
      setMobileMenuOpen(false);
    }

    // Sprawdź czy jesteśmy na właściwej stronie
    if (location.pathname !== currentPagePath) {
      // Przekierowanie na właściwą stronę z hash
      navigate(`${currentPagePath}#${sectionId}`);
      return;
    }

    // Jesteśmy na właściwej stronie, przewijamy do elementu
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      console.warn(
        `Element o ID ${sectionId} nie został znaleziony na stronie`
      );
    }
  };

  const otherPageLinks = getOtherPageLinks();

  return (
    <div className="bg-white">
      <header
        className="absolute inset-x-0 top-0 z-10"
        style={{ backgroundColor: "rgb(244, 244, 234)" }}
      >
        <nav
          className="flex items-center justify-between p-3 lg:px-8"
          aria-label="Global"
        >
          <div className="flex lg:flex-1">
            <Link to="/" className="-m-1.5 p-1.5">
              <span className="sr-only">Your Company</span>
              {/* Logo z określonymi wymiarami */}
              <div style={{ width: "56px", height: "56px" }}>
                {" "}
                {/* w-14 = 3.5rem = ~56px */}
                <picture>
                  <source srcSet={Logo} type="image/webp" />
                  <img
                    className="w-full h-full"
                    src={LogoFallback}
                    alt="Company Logo"
                    loading="eager" /* Zmieniono na eager dla logo w headerze */
                    width="56"
                    height="56"
                  />
                </picture>
              </div>
            </Link>
          </div>
          <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
              onClick={toggleMobileMenu}
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="hidden lg:flex lg:gap-x-12">
            {/* Nawigacja po aktualnej stronie */}
            {navigation.map((item) => (
              <button
                key={item.name}
                onClick={() => handleNavigation(item.href)}
                className="text-sm font-semibold hover:gray-400 leading-6 cursor-pointer p-1 rounded-3xl hover:bg-gray-50 text-gray-900 menu-link"
              >
                {item.name}
              </button>
            ))}

            {/* Linki do innych stron */}
            {otherPageLinks.map((page) => (
              <Link
                key={page.path}
                to={page.path}
                className="text-sm font-semibold hover:gray-400 leading-6 cursor-pointer p-1 rounded-3xl hover:bg-gray-50 text-gray-900 menu-link"
              >
                {page.name}
              </Link>
            ))}
          </div>
          <div className="hidden lg:flex lg:flex-1 lg:justify-end"></div>
        </nav>
        <Dialog
          as="div"
          className="lg:hidden"
          open={mobileMenuOpen}
          onClose={toggleMobileMenu}
        >
          <div className="fixed inset-0 z-50" />
          <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <Link
                to="/"
                className="-m-1.5 p-1.5"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Your Company</span>
                {/* Logo z określonymi wymiarami w menu mobilnym */}
                <div style={{ width: "56px", height: "56px" }}>
                  <picture>
                    <source srcSet={Logo} type="image/webp" />
                    <img
                      className="w-full h-full"
                      src={LogoFallback}
                      alt="Company Logo"
                      loading="eager"
                      width="56"
                      height="56"
                    />
                  </picture>
                </div>
              </Link>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                onClick={toggleMobileMenu}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  {/* Nawigacja po aktualnej stronie */}
                  {navigation.map((item) => (
                    <button
                      key={item.name}
                      onClick={() => handleNavigation(item.href)}
                      className="-mx-3 block w-full text-left rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50 menu-link"
                    >
                      {item.name}
                    </button>
                  ))}

                  {/* Linki do innych stron */}
                  {otherPageLinks.map((page) => (
                    <Link
                      key={page.path}
                      to={page.path}
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50 menu-link"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      {page.name}
                    </Link>
                  ))}
                </div>
                <div className="py-6"></div>
              </div>
            </div>
          </Dialog.Panel>
        </Dialog>
      </header>
    </div>
  );
};

export default Header;
